import React, { Component } from 'react';
import RegisterSuccessComponent from '../../components/auth/RegisterSuccess';
const RegisterSuccess = () => {
  return <div className="w-full py-16 bg-gray-100" data-id="element-608">
      <div className="container mx-auto px-4" data-id="element-609">
        <RegisterSuccessComponent data-id="element-610" />
      </div>
    </div>;
};
export default RegisterSuccess;